import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import CTAButton from '@components/CTAButton';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@components/Text';
import {
  Wrapper,
  ContentContainer,
  ButtonsContainer,
  MessageText,
} from './styles';

export class DeleteMessageConfirm extends Component {
  handleConfirm = () => {
    const { onConfirm, onClose } = this.props;
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  handleCancel = () => {
    const { onCancel, onClose } = this.props;
    if (onCancel) {
      onCancel();
    }
    onClose();
  };

  render() {
    const { t, message } = this.props;

    return (
      <Wrapper>
        <ContentContainer>
          <MessageText>
            <Text size={TEXT_SIZE.H4} textColor={TEXT_COLOR.DARK_BLUE}>
              {message || t('Actions.Confirmations.confirmDeleteMessage')}
            </Text>
          </MessageText>
          <ButtonsContainer>
            <CTAButton
              size="small"
              secondary
              onClick={this.handleCancel}
            >
              {t('Actions.Instance.cancel')}
            </CTAButton>
            <CTAButton
              size="small"
              variant="primary"
              onClick={this.handleConfirm}
            >
              {t('Actions.Instance.delete')}
            </CTAButton>
          </ButtonsContainer>
        </ContentContainer>
      </Wrapper>
    );
  }
}

DeleteMessageConfirm.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  message: PropTypes.string,
};

export default withTranslation()(DeleteMessageConfirm);
